var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('audio',{attrs:{"id":"background_2","src":"https://gurotoon2021.s3.ap-northeast-2.amazonaws.com/%EB%B0%B0%EA%B2%BD2.mp3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }